import { success } from '@/utils/alert'

export default {
  countSchedulings () {
    if (this.rule.schedulings) {
      if (this.rule.schedulings.length <= 0) {
        return false
      }

      if (this.rule.schedulings.length > 0) {
        return true
      }
    }
  },
  doRollBackuPublish (rule) {
    this.$resource.post(this.rule.id + '/roll-back')
        .then(({data}) => {
          this.rule = this.prepareShow(data)
          success('Publicação cancelada com sucesso.')
          this.publishing = false
          // ativa bitão de pre visualização apos publicação pelo preview
          this.publishedOnPreview = false
        })
  },
  doPublish () {
    this.show = false
    this.publishing = true
    this.$resource.put(this.rule.id + '/publish')
      .then(({data}) => {
        this.rule.published = data.rule.published
        this.agendaTitle = data.rule.agenda.name
        this.schedules = data.schedules
      })
  },
  doPreview () {
    this.show = false
    this.publishing = true
    this.$resource.put(this.rule.id + '/do-preview')
      .then(({data}) => {
        this.rule.published = data.rule.published
        this.agendaTitle = data.rule.agenda.name
        this.schedules = data.schedules
        this.showModal = true
      })
  },
  closeModal () {
    this.showModal = false
  },
  afterSave (rule) {
    this.rule = this.prepareShow(rule)
    this.disabledSave = true
  },
  afterCreated (rule) {
    this.wasRaised = true
    this.show = true
    this.rule = this.prepareShow(rule)
    // this.afterSave(rule)
  },
  afterUpdated (rule) {
    this.afterSave(rule)
    this.wasRaised = true
    this.show = true
  },
  gotToLock () {
    return this.$router.push({name: 'professional.agenda.locks.create'})
  },
  gotToNewRule () {
    return this.$router.push({name: 'professional.agenda.rules.create'})
  },
  /* clear object for ne rule */
  newRule () {
    this.rule = {
      agenda_id: null,
      interval: null,
      periodicity: 'weekley',
      sunday: false,
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      time_start: null,
      time_end: null,
      time_start_two: null,
      time_end_two: null,
      valid_to_start: null,
      valid_to_end: null,
      active: true,
      published: false
    }
    this.show = false
  },
  gotNextPreview () {
    this.$resource.get(this.rule.id + '/preview')
    .then(({data}) => {
      this.rule.published = data.published
      this.agendaTitle = data.agenda.name
      this.schedules = data.schedulings
      this.showModalPreview = true
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/form/resources/methods.js